<ex-sort-dropdown [items]="sortItems"
                  [defaultValue]="sort"
                  (sort)="onSort($event)"
                  [headerHeight]="inBoardView ? 32 : undefined"
                  useShortLabel
                  class="{{size}}"/>
